import { Stack } from "@mui/material"
import Hero from "./components/Hero"
import HarnessThePower from "./components/HarnessThePower"
import WhyChooseRenecLend from "./components/WhyChooseRenecLend"
import TrustedByOurInvestors from "./components/TrustedByOurInvestors"
import UnderstandingRenecLend from "./components/UnderstandingRenecLend"
import RenecLendInsights from "./components/RenecLendInsights"
import FeaturedIn from "./components/FeaturedIn"
import JoinWithUs from "./components/JoinWithUs"

const View = () => {
  return (
    <Stack className='mt-16 sm:mt-20 bg-white'>
      <Hero />
      <HarnessThePower />
      <WhyChooseRenecLend />
      <TrustedByOurInvestors />
      <UnderstandingRenecLend />
      <RenecLendInsights />
      <FeaturedIn />
      <JoinWithUs />
    </Stack>
  )
}

export default View
